// @flow
import { DOG_BARK, GLASS_BREAK, SMOKE_CO } from '~/core/constants/products-sense';

const PREFIX = 'hive/sense/';

export const CHANGE_SENSE_LOGS_SELECTED_DAY = `${PREFIX}CHANGE_SENSE_LOGS_SELECTED_DAY`;
export const DELETE_SENSE_EVENT = `${PREFIX}DELETE_SENSE_EVENT`;
export const DELETE_SENSE_EVENT_COMPLETE = `${PREFIX}DELETE_SENSE_EVENT_COMPLETE`;
export const FLAG_SENSE_MEDIA = `${PREFIX}FLAG_SENSE_MEDIA`;
export const FLAG_SENSE_MEDIA_COMPLETE = `${PREFIX}FLAG_SENSE_MEDIA_COMPLETE`;
export const GET_SENSE_HUB_OFFLINE_NOTICATIONS_STATUS = `${PREFIX}hub-offline-notifications-status/get`;
export const GET_SENSE_DAY_EVENT_LOGS = `${PREFIX}GET_SENSE_DAY_EVENT_LOGS`;
export const RECEIVE_SENSE_DAY_EVENT_LOGS = `${PREFIX}RECEIVE_SENSE_DAY_EVENT_LOGS`;
export const RECEIVED_SENSE_HUB_OFFLINE_NOTICATIONS_STATUS = `${PREFIX}hub-offline-notifications-status/received`;
export const SET_DEFAULT_MUTING = `${PREFIX}monitoring/set-default-muting`;
export const SET_DEFAULT_MUTING_DONE = `${PREFIX}monitoring/set-default-muting/done`;
export const SET_SENSE_HUB_OFFLINE_NOTICATIONS_STATUS = `${PREFIX}hub-offline-notifications-status/set`;
export const STOP_SENSE_DAY_EVENT_LOGS_POLLING = `${PREFIX}day-event-logs/polling/stop`;
export const TOGGLE_MONITORING_ALL = `${PREFIX}monitoring/toggle/all`;
export const TOGGLE_MONITORING_ALL_DONE = `${PREFIX}monitoring/toggle/all/done`;
export const TOGGLE_MONITORING_SENSOR = `${PREFIX}monitoring/toggle/sensor`;
export const TOGGLE_MONITORING_SENSOR_DONE = `${PREFIX}monitoring/toggle/sensor/done`;

export const defaultMuting = {
    mute: false,
    sensors: {
        [DOG_BARK]: true,
        [GLASS_BREAK]: true,
        [SMOKE_CO]: true
    }
};



// WEBPACK FOOTER //
// ./src/core/state/products/sense/constants.js